import { createAction } from "redux-actions";
import { LOGIN, LOGIN_FAILED } from "./Login.constants";
import { IAuthentication } from "./Login.models";

export const logIn = createAction<IAuthentication>(LOGIN);
export const logInFailed = createAction(LOGIN_FAILED);
